import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import config from 'config';
import { GuardProps } from 'types';
import { useEffect } from 'react';
import { getAppDataStore, setAppDataStore } from 'features/firebase-app';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }: GuardProps) => {
    const { isLoggedIn } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        let hash = `${window.location.hash}`.split('#').join('')
        const searchParams = new URLSearchParams(hash);
        let redirectUrl = searchParams.get('redirectUrl');
        if (redirectUrl) {
            setAppDataStore('redirectUrl', redirectUrl);
        }
        if (isLoggedIn) {
            if (config.mobileConnectPath && getAppDataStore('mobile')) {
                navigate(`${config.mobileConnectPath}${redirectUrl ? `#redirectUrl=${redirectUrl}` : ``}`, { replace: true });
            }
            else {
                navigate(config.defaultPath, { replace: true });
            }
        }
    }, [isLoggedIn, navigate]);

    return children;
};

export default GuestGuard;
